import './ServiceHomePageCard.css';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';

const ServiceHomePageCard = ({ service_cards }) => {
  const service_card = service_cards.map((sc, index) => {
    return (
      <a key={index} className='card' href={sc.link}>
        <div className={sc.className}>
          <div className={sc.box_className}>
            <img className='mini-img' src={sc.mini_image} alt='service logo' />
          </div>
          {/* Nothing in CSS sizes this image, so the card row stays even only
              because the 1x files share dimensions. Using x-descriptors keeps
              that intact: the browser lays out from the 1x intrinsic size and
              swaps in the 2x file only where the display can use it. */}
          <img
            src={sc.main_image}
            srcSet={
              sc.main_image_2x
                ? `${sc.main_image} 1x, ${sc.main_image_2x} 2x`
                : undefined
            }
            alt='service'
          />
          <div className='card-desc'>
            <p className='card-title'>{sc.title}</p>
            <p className='card-info'>{sc.description}</p>
            <div className='learn-more'>
              <p>Learn more</p>
              <aside><EastOutlinedIcon/></aside>
            </div>
          </div>
        </div>
      </a>
    );
  })
  return (
    <div className='cards'>{service_card}</div>
  )
}

export default ServiceHomePageCard;